if (!customElements.get('skip-open')) {

  class SkipOpen extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      document.addEventListener('rebuy:smartcart.init', (event) => {
        console.log('rebuy:smartcart.init event', event.detail);
        Rebuy.SmartCart.skip_open = true;
      });
    }

    disconnectedCallback() {
      document.removeEventListener('rebuy:smartcart.init', (event) => {
        console.log('rebuy:smartcart.init event', event.detail);
        Rebuy.SmartCart.skip_open = true;
      });
    }

  }

  customElements.define('skip-open', SkipOpen);

}